import { Injectable } from '@angular/core';
import { FormName } from '@nx-customer-apps/shared/enums';
import { PrefillState } from '@nx-customer-apps/shared/interfaces';
import { Observable, Subject } from 'rxjs';

interface HeatPumpIntermediaryPrefillState {
    [FormName.Building]: PrefillState;
    [FormName.Device]: PrefillState;
    [FormName.LivingArea]: PrefillState;
    [FormName.EnergySource]: PrefillState;
    [FormName.EnergyConsumption]: PrefillState;
    [FormName.HeatGeneratorDetails]: PrefillState;
    [FormName.HeatingDistribution]: PrefillState;
    [FormName.SubsidyEligibility]: PrefillState;
}

@Injectable({
    providedIn: 'root'
})
export class HeatPumpIntermediaryPrefillService {
    public state$: Observable<HeatPumpIntermediaryPrefillState>;
    private _state$: Subject<HeatPumpIntermediaryPrefillState> = new Subject();
    private state: HeatPumpIntermediaryPrefillState;

    constructor() {
        this.state$ = this._state$.asObservable();
    }

    public init(): void {
        this.state = {
            [FormName.Building]: { isPrefilled: false },
            [FormName.Device]: { isPrefilled: false },
            [FormName.LivingArea]: { isPrefilled: false },
            [FormName.EnergySource]: { isPrefilled: false },
            [FormName.EnergyConsumption]: { isPrefilled: false },
            [FormName.HeatGeneratorDetails]: { isPrefilled: false },
            [FormName.HeatingDistribution]: { isPrefilled: false },
            [FormName.SubsidyEligibility]: { isPrefilled: false }
        };
    }

    public setAsPrefilled(formName: FormName): void {
        if (this.state.hasOwnProperty(formName)) {
            (this.state as any)[formName].isPrefilled = true;
            this._state$.next(this.state);
        }
    }

    public isPrefilled(formName: FormName): boolean {
        return (this.state as any)[formName].isPrefilled;
    }
}
